import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e7b1cad8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = ["onClick"]
const _hoisted_3 = ["onClick"]

import { WorkspaceRmodel } from '@/app.context/workspace.rmodel';
import { PersonRmodel } from '@/app.context/workspace/person.rmodel';
import { GroupRmodel } from '@/app.context/workspace/persons.set/group.rmodel';
import { Guid } from '@/lib';
import { reactive } from 'vue';



export default /*#__PURE__*/_defineComponent({
  __name: 'MeetingParticipantsPicker',
  props: {
    workspace: {}
  },
  setup(__props: any, { expose: __expose }) {

const props = __props
const request: {


persons: Set<PersonRmodel>
groups: Set<GroupRmodel>




} =
reactive({
    
    persons: new Set<PersonRmodel>(),
    groups: new Set<GroupRmodel>()

})

function toggle_group(g:GroupRmodel){

    if (request.groups.has(g)) request.groups.delete(g); else request.groups.add(g)
}

function toggle_person(g:PersonRmodel){

if (request.persons.has(g)) request.persons.delete(g); else request.persons.add(g)
}


__expose({participants:function(){

    const x:{persons:Guid[], groups:Guid[]} = {persons:[], groups:[]}

    request.persons.forEach(p => x.persons.push(p.nid))
    request.groups.forEach(g => x.groups.push(g.uid))

    return x

}})


return (_ctx: any,_cache: any) => {
  return (_ctx.workspace != null)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.groups(), (g) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (toggle_group(g)),
            class: _normalizeClass([{'meeting-participant-picked':request.groups.has(g)}, "bi bi-people-fill meeting-participant"]),
            key: g.name
          }, " " + _toDisplayString(g.name), 11, _hoisted_2))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.workspace.persons(), (p) => {
          return (_openBlock(), _createElementBlock("span", {
            onClick: ($event: any) => (toggle_person(p)),
            class: _normalizeClass([{'meeting-participant-picked':request.persons.has(p)}, "meeting-participant"]),
            key: p.nid.toString()
          }, _toDisplayString(p.name), 11, _hoisted_3))
        }), 128))
      ]))
    : _createCommentVNode("", true)
}
}

})